import { Token } from "./Token";
import { ResponseBase } from "../base/ResponseBase";

export class TokenResponse extends Token implements ResponseBase {
    success: boolean = false;
    message!: string;
    errorCode?: number;
}